module.exports = __webpack_public_path__ + "static/media/j.479f3bb8.jpg";